// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"ed4ac977","453":"8113006e"}[chunkId] + ".chunk.js";
};